module.exports = __webpack_public_path__ + "static/media/02.09adc42e.png";